import { css, jsx } from '@emotion/core';
import { Divider } from 'antd';
import React from 'react';

import Sanitize from '@/src/shared/components/Sanitize';
import { bp, colors } from '@/styles';

const styles = {
  cardContainer: css`
    border-radius: 4px;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    background-color: ${colors.white};
  `,
  cardTitle: css`
    text-align: center;
    font-weight: 900;
    line-height: 44px;
    font-size: 36px;
    color: ${colors.secondaryGrayDark};
    padding-top: 4rem;
    margin-bottom: 2.4rem;
    @media ${bp.lg} {
      margin-bottom: 2rem;
      padding-top: 3.5rem;
    }
  `,
  cardSubtitle: css`
    max-width: 76.8rem;
    margin: 0 auto;
    text-align: center;
    font-size: 1.6rem;
  `,
};

const Card = ({
  children,
  title,
  subTitle,
  footer,
  containerStyle,
  titleStyle = null,
  subTitleStyle = null,
}) => {
  return (
    <div css={[styles.cardContainer, containerStyle]} id="registration-form">
      <h2 css={[styles.cardTitle, titleStyle]}>{title}</h2>
      <Sanitize css={[styles.cardSubtitle, subTitleStyle]}>{subTitle}</Sanitize>
      <Divider />
      {children}
      {footer}
    </div>
  );
};

export default Card;
